<template>
    <BreadCrumb PageTitle="Liste des maisons d'édition" />
    <ListeMaisonEdition />
  </template>
  
  <script lang="ts">
  import { defineComponent } from "vue";
  
  import BreadCrumb from "../../components/Common/BreadCrumb.vue";
  import ListeMaisonEdition from "../../components/MaisonEdition/ListeMaisonEdition.vue";

  export default defineComponent({
    name: "ListeMaisonEditionPage",
    components: {
      BreadCrumb,
      ListeMaisonEdition,
    },
  });
  </script>